export default __webpack_public_path__ + "static/media/Famiglia_felice.4a151ea9.jpg";